<script>
export default {
  data() {
    return {}
  },
  mounted() {},
  methods: {}
}
</script>
<template>
  <div class="blank-page">
    <img class="blank-page_img" src="./img/blank.png" />
    <div class="blank-page_desc">内容不存在或已被删除</div>
  </div>
</template>
<style lang="scss">
.blank-page {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 125px;
}
.blank-page_img {
  width: 162px;
  height: 133px;
}
.blank-page_desc {
  margin-top: 20px;
  font-size: 18px;
  font-weight: 500;
  color: #444444;
  line-height: 28px;
}
// @media screen and (max-width: 940px) {
//   .blank-page_desc {
//     font-size: 20px;
//   }
// }
</style>
